import {deserialize, deserializeAs} from 'cerialize';
import {EnergieEnum} from '../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';


export class Consommation {

  @deserializeAs(Date)
  date: Date = null;

  @deserializeAs(EnergieEnum)
  energie: EnergieEnum;

  @deserialize
  value: number;

}
